// extracted by mini-css-extract-plugin
module.exports = {"codelistChips":"CodelistEditor_codelistChips__2d-F7","inputTitleWrapper":"CodelistEditor_inputTitleWrapper__3SdeY","pasteDiv":"CodelistEditor_pasteDiv__1AVPj"};